import { OrganizationType, type SearchV1PeopleListParams } from '@on3/api';
import clsx from 'clsx';

import { SearchKeys } from '..';
import styles from './OrganizationLevelFilter.module.scss';

interface IOrganizationLevelFilterProps {
  className?: string;
  currentOrganizationLevel?: SearchV1PeopleListParams['currentOrganizationLevel'];
  handleFieldUpdate: (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => void;
}
export const OrganizationLevelFilter = ({
  className,
  currentOrganizationLevel,
  handleFieldUpdate,
}: IOrganizationLevelFilterProps) => {
  return (
    <div
      className={clsx(styles.block, className)}
      data-sort-type={currentOrganizationLevel || 'All'}
    >
      <button
        aria-label="High School"
        data-name={OrganizationType.HighSchool}
        name={SearchKeys.CURRENT_ORGANIZATION_LEVEL}
        onClick={handleFieldUpdate}
        type="button"
        value={OrganizationType.HighSchool}
      >
        h.s.
      </button>
      <button
        aria-label="Junior College"
        data-name={OrganizationType.JuniorCollege}
        name={SearchKeys.CURRENT_ORGANIZATION_LEVEL}
        onClick={handleFieldUpdate}
        type="button"
        value={OrganizationType.JuniorCollege}
      >
        juco
      </button>
      <button
        data-name={OrganizationType.College}
        name={SearchKeys.CURRENT_ORGANIZATION_LEVEL}
        onClick={handleFieldUpdate}
        type="button"
        value={OrganizationType.College}
      >
        college
      </button>
      <button
        data-name="All"
        name={SearchKeys.CURRENT_ORGANIZATION_LEVEL}
        onClick={handleFieldUpdate}
        type="button"
        value={undefined}
      >
        all
      </button>
    </div>
  );
};
